import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgManage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6 3C6.55228 3 7 3.44772 7 4V13C8.10457 13 9 13.8954 9 15V17C9 18.1046 8.10457 19 7 19V20C7 20.5523 6.55228 21 6 21C5.44772 21 5 20.5523 5 20V19C3.89543 19 3 18.1046 3 17V15C3 13.8954 3.89543 13 5 13V4C5 3.44772 5.44772 3 6 3ZM5 15V17H7V15H5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18 3C18.5523 3 19 3.44772 19 4V13C20.1046 13 21 13.8954 21 15V17C21 18.1046 20.1046 19 19 19V20C19 20.5523 18.5523 21 18 21C17.4477 21 17 20.5523 17 20V19C15.8954 19 15 18.1046 15 17V15C15 13.8954 15.8954 13 17 13V4C17 3.44772 17.4477 3 18 3ZM17 15V17H19V15H17Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 21C12.5523 21 13 20.5523 13 20V11C14.1046 11 15 10.1046 15 9V7C15 5.89543 14.1046 5 13 5V4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V5C9.89543 5 9 5.89543 9 7V9C9 10.1046 9.89543 11 11 11V20C11 20.5523 11.4477 21 12 21ZM11 9V7H13V9H11Z",
			fill: "currentColor"
		})
	]
});
export default SvgManage;
